export default "__VITE_ASSET__DN$Amdoz__"